import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';

const financingDataForm: Form<Client> = {
  key: 'financingData',
  title: 'Finanzierung',
  fields: [
    {
      key: 'fundingProvidedBy',
      label: 'Finanzierung',
      fieldTypes: 'select',
      xsWidth: 6,
      options: [
        { value: 'algi', label: 'ALGI' },
        { value: 'jobcenter', label: 'Jobcenter' },
        { value: 'directPayer', label: 'Selbstzahler' },
      ],
    },
    {
      key: 'fundingNumber',
      label: 'Nummer',
      fieldTypes: 'text',
      xsWidth: 6,
    },
    {
      key: 'fundingValidFrom',
      label: 'gültig ab',
      fieldTypes: 'date',
      xsWidth: 6,
    },
    {
      key: 'fundingValidTill',
      label: 'gültig bis',
      fieldTypes: 'date',
      xsWidth: 6,
    },
  ],
};

export default financingDataForm;
